import React from 'react'
import { bool, string } from 'prop-types'
import { Button, ButtonProps } from '@livechat/design-system-react-components'

import { getAlternativeSettingUrl, getPublishedApp } from '@/store/selectors'
import { pushGenericEvent } from '@/utils/analytics'
import useParamSelector from '@/hooks/useParamSelector'
import { useTypedDispatch } from '@/store/hooks'
import { logAmplitudeEvent } from '@/store/stats'
import { AMPLITUDE_EVENTS } from '@/constants'

interface Props extends ButtonProps {
  id: string
  className?: string
}

export const OpenAppButton = ({ className, fullWidth, size, id }: Props) => {
  const dispatch = useTypedDispatch()

  const product = useParamSelector(getPublishedApp, id)
  const alternativeSettingsUrl = useParamSelector(getAlternativeSettingUrl, id)

  const handleOpenAlternativeSettings = () => {
    pushGenericEvent({
      action: 'OpenApp',
      label: id,
    })

    dispatch(
      logAmplitudeEvent({
        name: `${AMPLITUDE_EVENTS.OPEN_APP_CLICKED} - open internal product`,
        params: {
          appId: id,
          appName: product?.name,
        },
      })
    )

    window.open(alternativeSettingsUrl)
  }

  return (
    <Button
      kind="primary"
      size={size}
      className={className}
      fullWidth={fullWidth}
      onClick={handleOpenAlternativeSettings}
    >
      Open App
    </Button>
  )
}

OpenAppButton.propTypes = {
  className: string,
  fullWidth: bool,
  size: string,
  id: string,
}

export default OpenAppButton
